module.exports = __webpack_public_path__ + "img/4-01-06-first-aid.78b85e95.svg";